import MasterService from './MasterService';

export const IfService = {
    ...MasterService,
    
   
    getIfSchemType(body){ 
        return this.post("inventoryFunding/ifSchemes",body)
    },
    saveIfScheme(body){ 
        return this.post("inventoryFunding/saveIfScheme",body)
    },
    getAllIfSchemeV2(body){ 
        return this.post("inventoryFunding/getAllIfV2",body)
    },
    updateStatus(body){ 
        return this.post("inventoryFunding/updateIfSchemeStatus",body)
    },
    getIfConfig(body){ 
        return this.get("inventoryFunding/masterConfig",body)
    },
    updateTargetStatus(body){ 
        return this.post("inventoryFunding/updateTargetStatus",body)
    },
    calculateAllIncentive(body){ 
        return this.post("inventoryFunding/calculate_all_if_schemes", body);
    },

   
}
